<!--
 * @Author:yeqing
 * @Date: 2021-11-24 10:30:57
 * @LastEditTime: 2022-05-13 11:54:34
 * @LastEditors: yeqing
 * @Description: 特新能力测评组件
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\smEvaluation\components\specialNewModel.vue
-->
<template>
  <div class="specialNewModel">
    <a-form>
      <a-form-item
        label="1、企业主导产品属于产业链“卡脖子”环节，或属于关键领域“补短板”，或属于填补国内(国际)空白，或有效实现进口产品替代"
      >
        <a-radio-group name="radioGroup" v-model="specialNew.q431">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="2、近两年企业是否主持或参与制(修)订相关领域国际标准、国家标准、行业标准或地方标准数量，或近两年主持或参与国家重大科研课题数量"
      >
        <a-radio-group name="radioGroup" v-model="specialNew.q432">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="3、企业是否有上市计划(已向证监局提交IPO报辅申请并获受理；或已签订保荐机构)(含新三板精选层)"
      >
        <a-radio-group
          name="radioGroup"
          v-model="specialNew.q433"
          @change="focusNextInput(-1)"
        >
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <div>
        <div class="lable">4、与主导产品(服务)相关的授权发明专利数量</div>
        <table class="table" border="1" ref="table">
          <thead>
            <th>知识能力</th>
            <th>数量（单位：项）</th>
          </thead>
          <tr>
            <td>与主导产品(服务)相关的授权发明专利数量</td>
            <td>
              <a-input
                name="input"
                v-model="specialNew.q434[0]"
                @pressEnter="focusNextInput(0)"
              />
            </td>
          </tr>
          <tr>
            <td>
              首台套产品认定，新技术新产品的数量(包括在研创新药、改良型新药和生物类似药II期、III期临床批件数量和药品批准文号等数量)
            </td>
            <td>
              <a-input
                name="input"
                v-model="specialNew.q434[1]"
                @pressEnter="focusNextInput(1)"
              />
            </td>
          </tr>
          <tr>
            <td>与主导产品(服务)相关的软件著作权数量</td>
            <td>
              <a-input
                name="input"
                v-model="specialNew.q434[2]"
                @pressEnter="focusNextInput(2)"
              />
            </td>
          </tr>
          <tr>
            <td>与主导产品(服务)相关的实用新型专利数量</td>
            <td>
              <a-input
                name="input"
                v-model="specialNew.q434[3]"
                @pressEnter="focusNextInput(3)"
              />
            </td>
          </tr>
          <tr>
            <td>与主导产品(服务)相关的外观专利数量</td>
            <td>
              <a-input
                name="input"
                v-model="specialNew.q434[4]"
                @pressEnter="focusNextInput(4)"
              />
            </td>
          </tr>
        </table>
      </div>
      <a-form-item label="5、企业上一年度主营业务收入占营业收入比重50%以上">
        <a-radio-group name="radioGroup" v-model="specialNew.q435">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="6、企业年度经营、净利润、融资情况" class="block">
        <a-radio-group name="radioGroup" v-model="specialNew.q436">
          <a-radio value="上年度企业营业收入达到1500万元及以上"
            >上年度企业营业收入达到1500万元及以上</a-radio
          >
          <a-radio value="近两年企业净利润累计不低于600万元"
            >近两年企业净利润累计不低于600万元</a-radio
          >
          <a-radio value="企业最新一轮融资估值不低于1亿元"
            >企业最新一轮融资估值不低于1亿元</a-radio
          >
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="7、企业近两年主营业务平均增长率10%以上，或近两年净利润平均增长率10%以上"
      >
        <a-radio-group name="radioGroup" v-model="specialNew.q437">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="8、企业上一年度研发费用投入不低于100万元">
        <a-radio-group name="radioGroup" v-model="specialNew.q438">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="9、企业近两年研发经费支出占营业收入的比重均不低于5%">
        <a-radio-group name="radioGroup" v-model="specialNew.q439">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="10、企业是否自建或与高校、科研机构联合建立研发机构(技术研究院、企业技术中心、企业工程中心、院士专家工作站、博士后工作站等)"
      >
        <a-radio-group name="radioGroup" v-model="specialNew.q4310">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <div style="text-align: center; margin-top: 40px;">
        <a-button class="primary-btn pre-btn" @click="handlePre"
          >上一步</a-button
        >
        <a-button
          type="primary"
          class="primary-btn"
          @click="handleSubmit"
          :loading="loading"
          >获取报告</a-button
        >
      </div>
    </a-form>
  </div>
</template>

<script>
export default {
  name: "specialNewModel",
  props: {
    loading: Boolean,
  },
  data() {
    return {
      specialNew: {
        q431: "",
        q432: "",
        q433: "",
        q434: [],
        q435: "",
        q436: "",
        q437: "",
        q438: "",
        q439: "",
        q4310: "",
      },
    };
  },
  methods: {
    // input回车聚焦
    focusNextInput(thisInput) {
      var inputs = document.getElementsByName("input");
      for (let i = thisInput + 1; i < inputs.length; i++) {
        if (!this.specialNew.q434[i]) {
          inputs[i].focus();
          break;
        }
      }
    },

    formatNumber(e, tag) {
      tag = Number(tag);
      const { value } = e.target;
      const reg = /^-?[0-9]\d*$/;
      if (!isNaN(value) && reg.test(value)) {
        this.specialNew.q434[tag] = Number(value);
        console.log(this.specialNew.q434);
      }
    },
    // 上一步
    handlePre(e) {
      e.preventDefault();
      this.$emit("changeTabKey", {
        name: "specialNew",
        key: 2,
        data: this.specialNew,
      });
    },

    // 立即测评
    handleSubmit(e) {
      e.preventDefault();
      const { q434 } = this.specialNew;
      if (q434[0] && q434[1] && q434[2] && q434[3] && q434[4]) {
        this.$emit("handleSubmit", this.specialNew);
      } else {
        this.$message.error("您有未填写的企业信息，请补全完成");
      }
    },

    // 监听table距离顶部的高度
    handleScrollx() {
      if (
        this.$refs.table.getBoundingClientRect().top <
        document.body.clientHeight / 3
      ) {
        this.focusNextInput(-1);
      }
    },
  },

  mounted() {
    window.addEventListener("scroll", this.handleScrollx, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
};
</script>
<style lang="less" scoped>
.specialNewModel {
  margin-top: 30px;
  .lable {
    margin: 0;
    padding: 0 0 8px;
    line-height: 39.9999px;
    white-space: initial;
    text-align: left;
    // font-family: PingFangSC-Regular, PingFang SC;
    color: #333333;
    margin-right: 6px;
    font-size: 14px;
    display: inline-block;
  }
  .table {
    width: 100%;
    // height: 195px;
    border: 1px solid #f0f0f0;
    margin-top: 14px;
    margin-bottom: 30px;
    th {
      height: 38px;
      background: #fafafa;
      // line-height: 38px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      padding: 0 20px;
      text-align: center;
      // &:nth-child(1){
      // 	width: 270px;
      // }
    }

    td {
      height: 38px;
      // line-height: 38px;
      // height: 14px;
      font-size: 14px;
      // font-weight: 400;
      color: #333333;
      padding: 0 20px;
      // font-family: PingFangSC-Regular, PingFang SC;
    }
    input {
      width: 100%;
      // height: 100%;
      // border: none;
      border-color: #f0f0f0;
      outline: none;
      padding: 0;
      text-align: center;
    }
    // input:focus {
    //   outline: none;
    //   border: none;
    //   box-shadow: none;
    // }
  }
  .desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    margin-top: 17px;
  }
}
</style>
